import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';

export const NCRTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 580,
    backgroundColor: "#F6F6F6",
    color: '#000000',
    border: '1px solid #D3D3D399',
    padding: "10px",
  }, [`& .${tooltipClasses.arrow}`]: {
    color: "#F6F6F6",
  },
})

export default function NCRFormHeading(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Typography
        className={props.className || 'ncr-form-heading'}
        variant={props.variant || 'h2'}
        sx={{
          fontFamily: 'Lato, sans-serif',
          fontSize: '16px',
          fontWeight: '700',
          lineHeight: '19.2px',
          color: 'rgba(0, 0, 0, 1)',
          mb: '4px',
          ...props.sx,
        }}
      >
        {props.children}
        {props.isRequired && (
          <span style={{ fontSize: '20px', color: 'rgba(255, 0, 0, 1)', fontWeight: '700', marginLeft:'2px' }}>*</span>
        )}
      </Typography>
      {Array.isArray(props.tooltipData) && props.tooltipData.length > 0 && (
        <NCRTooltip
          title={
            <div>
              {props.tooltipData.map((item, index) => (
                <Typography key={index} variant="body2"
                  sx={{
                    fontFamily: 'Lato, sans-serif',
                    fontSize: '14px',
                    fontWeight: '700',
                    lineHeight: '20px',
                  }}
                >
                  {item.title && <strong>{item.title}: </strong>}
                  <span style={{ fontWeight: '400' }}>{item.description}</span>
                </Typography>
              ))}
            </div>
          }
          placement="bottom-start"
          slotProps={{
            popper: { modifiers: [{ name: "offset", options: { offset: [0, -5] } }] },
          }}
        >
          <IconButton>
            <img
              src="/images/tooltipIcon.png"
              alt="NC Pro Information icon"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </IconButton>
        </NCRTooltip>
      )}
    </Box>
  )
}
